import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import ControlledInputZipcode from '../../../components/InputComponents/InputZipcode/ControlledInputZipcode';
import SlideHouseholdIncome from '../../../components/InputComponents/SlideHouseholdIncome/SlideHouseholdIncome';
import SelectHouseholdSize from '../InputComponents/SelectHouseholdSize/SelectHouseholdSize';
import ChooseTaxFilingStatus from '../InputComponents/ChooseTaxFilingStatus/ChooseTaxFilingStatus.js';
import ChooseCanTurnInClunker from '../InputComponents/ChooseCanTurnInClunker/ChooseCanTurnInClunker';
import SelectElectricityProvider from '../InputComponents/SelectElectricityProvider/SelectElectricityProvider';
import SelectVehicleMakeFilter from '../../../components/InputComponents/SelectVehicleMakeFilter/SelectVehicleMakeFilter';
import SelectVehicleModelFilter from '../../../components/SelectVehicleModelFilter/SelectVehicleModelFilter';
import SelectVehicleTrimFilter from '../InputComponents/SelectVehicleTrimFilter/SelectVehicleTrimFilter';
import SelectPurchaseMethod from '../../../components/InputComponents/SelectPurchaseMethod/SelectPurchaseMethod';
import EVAgeFilter from '../InputComponents/EVAgeFilter/EVAgeFilter';

import ToolTip from '../../../components/shared/ToolTip/ToolTip';
import UserPrefsContext from '../../../context/UserPrefs/UserPrefsContext';
import { ValidateFiveDigitCode } from '../../../utils/Helpers/USPostalCodeValidator';

import { FormattedMessage, useIntl } from 'react-intl';

import './IncentiveScoreOptions.scss';

const IncentiveScoreOptions = ({ userLocation, electricVehicles, mobile }) => {
  const userPrefs = useContext(UserPrefsContext);
  const [workingZipcode, setWorkingZipcode] = useState(
    userPrefs.get('zipcode')
  );
  const intl = useIntl();
  
  const handleFormSubmit = () => {
    if (ValidateFiveDigitCode(workingZipcode)) {
      userPrefs.syncWorkingZipcode();
      userPrefs.toggleIncentivePrefsModal();
    }
  };
  const RenderItem = ({ component, tooltip_id, title_id, message }) => (
    <div style={{lineHeight: "0px"}}>
      <div className="incentive-label-select">
        <FormattedMessage
          id={title_id}
          defaultMessage={'Item Title'}
          description={'Item Title'}
        />
        {tooltip_id ? <ToolTip message={message} id={tooltip_id} /> : null}
      </div>
      {component}
    </div>
);

  return (
    <div className="input-well MatchScoreOptions">
      <div style={{ marginBottom: '20px' }}>
        <ControlledInputZipcode
          zipcode={workingZipcode}
          handleSubmit={(e) => {
            handleFormSubmit();
          }}
          workingZipcode={workingZipcode}
          setZipcode={(e) => {
            setWorkingZipcode(e.target.value);
            if (ValidateFiveDigitCode(e.target.value)) {
              userPrefs.set({ workingZipcode: e.target.value });
            }
          }}
          id="input-zipcode-for-rate-comp-launch"
          isUpdating={userPrefs.zipcodeIsUpdating}
          isNotFound={userPrefs.zipcodeIsNotFound}
          hideValidateRequest
          tooltip={intl.formatMessage({
            id: 'zipcodeTooltip',
            defaultMessage: 'Zip code is used to display available incentives',
          })}
          userLocation={userLocation}
        />
      </div>
      <RenderItem
        component={<SelectElectricityProvider location={userLocation} />}
        title_id={'incentives.electricityProvider'}
      />
      <RenderItem
        component={<EVAgeFilter location={electricVehicles} />}
        tooltip_id="ev_age_tooltip"
        title_id={'incentives.evAge'}
        message="EV Age Tooltip."
      />
      <SelectVehicleMakeFilter vehicles={electricVehicles} />
      <SelectVehicleModelFilter
        vehicles={electricVehicles}
        makeOption={userPrefs.get('vehicleMakeFilter')}
      />
      <SelectVehicleTrimFilter
        vehicles={electricVehicles}
        makeOption={userPrefs.get('vehicleMakeFilter')}
        modelOption={userPrefs.get('vehicleModelFilter')}
      />
      <SelectPurchaseMethod incentives={true} />
      <RenderItem
        component={<ChooseCanTurnInClunker />}
        tooltip_id="trade_in_tooltip"
        title_id={'incentives.tradeIn'}
        message="Retiring an old gas vehicle may be required for certain incentives."
      />
      <RenderItem
        component={<SlideHouseholdIncome />}
        tooltip_id="household_income_tooltip"
        title_id={'incentives.householdIncome'}
        message="Combine income from all household members. Used to determine incentive eligibility."
      />
      <RenderItem
        component={<SelectHouseholdSize />}
        tooltip_id="household_size_tooltip"
        title_id={'incentives.householdSize'}
        message="Include all members of your household (spouse, dependants, etc). Used to determine incentive eligibility."
      />
      <RenderItem
        component={<ChooseTaxFilingStatus />}
        tooltip_id="filing_status_tooltip"
        title_id={'incentives.taxFilingStatus'}
        message="Used to determine incentive eligibility."
      />
      {!mobile ? (
        <p className="disclaimer">
          <FormattedMessage
            id="incentives.disclaimer"
            defaultMessage="Incentive eligibility and amounts do not constitute tax or legal
              advice. Consult the incentive grantor and/or your tax or legal
              professional to determine eligibility, specific amount of
              incentives or rebates available."
            description="Electric vehicle incentives"
          />
        </p>
      ) : null}
    </div>
  );
};

export default IncentiveScoreOptions;

IncentiveScoreOptions.propTypes = {
  electricVehicles: PropTypes.array,
};
